export default {
    state: {
        selectedSideBar: "",
    }
}